import {Center, createListCollection, Flex, Link, ListCollection, Select, Stack, Text} from '@chakra-ui/react'
import {userApi} from "../api/user-api";
import {useRecoilState} from "recoil";
import {companiesData, companyData, companyOperatorsData, executorData, profileData, useCleanData, userData, userLoginResultData} from "./hooks/recoilData";
import React, {useCallback, useEffect, useState} from "react";
import {useToast} from "@chakra-ui/toast";
import {dataApi} from "../api/data-api";
import InitDlg from "./InitDlg";
import {NavLink} from "react-router";
import {LuLogOut, LuUser} from "react-icons/lu";

const Header = () => {
    const [user] = useRecoilState(userData);
    const [userLoginResult] = useRecoilState(userLoginResultData);
    const [cleanData] = useCleanData();
    const toast = useToast();
    const logout = useCallback(() => {
        userApi.logout()
            .then((o) => {
                cleanData();
            })
            .catch((err) => {
                console.log("Login error status code is: " + err);
                toast({
                    title: "Logout error",
                    description: `code: [${err}]`,
                    status: "error"
                })
            });
    }, [cleanData, toast]);

    // const [user, setUser] = useRecoilState(userData);
    const [profile, setProfile] = useRecoilState(profileData);
    const [executor, setExecutor] = useRecoilState(executorData);
    const [company, setCompany] = useRecoilState(companyData);
    const [companies, setCompanies] = useRecoilState(companiesData);
    const [companyOperators, setCompanyOperators] = useRecoilState(companyOperatorsData);

    const [companiesList, setCompaniesList] = useState<ListCollection>(createListCollection({items: []}));

    useEffect(() => {
        if (!user)
            return;
        if (!profile && !executor && !companies && !companyOperators) {
            userApi.profileOwnGet()
                .then((o) => {
                    if (!o)
                        return;
                    setProfile(o);
                })
                .catch((err) => {
                    console.log("Login error status code is: " + err)
                });
            if (userLoginResult) {
                if (userLoginResult.isExecutor) {
                    dataApi.executorOwnGet()
                        .then((o) => {
                            if (!o)
                                return;
                            setExecutor(o);
                        })
                        .catch((err) => {
                            console.log("Login error status code is: " + err)
                        });
                } else if (userLoginResult.isEmployer) {
                    dataApi.companyOwnGet()
                        .then((o) => {
                            if (!o)
                                return;
                            let f = o[0];
                            if (!f)
                                return;
                            setCompany(f);
                            setCompanies(o);
                            setCompaniesList(createListCollection({
                                items: o.map(it => {
                                    return {label: it.NAME, value: String(it.ID)}
                                }),
                            }));
                        })
                        .catch((err) => {
                            console.log("Login error status code is: " + err)
                        });
                } else if (userLoginResult.isOperator) {
                    dataApi.operatorListOwn()
                        .then((o) => {
                            if (!o)
                                return;
                            let f = o[0];
                            if (!f)
                                return;
                            setCompanyOperators(o);
                            dataApi.companyForOperatorList(f.ID)
                                .then((o) => {
                                    if (!o)
                                        return;
                                    let f = o[0];
                                    if (!f)
                                        return;
                                    setCompany(f);
                                    setCompanies(o);
                                    setCompaniesList(createListCollection({
                                        items: o.map(it => {
                                            return {label: it.NAME, value: String(it.ID)}
                                        }),
                                    }));
                                })
                                .catch((err) => {
                                    console.log("Login error status code is: " + err)
                                });
                        })
                        .catch((err) => {
                            console.log("Login error status code is: " + err)
                        });
                }
            }
        }
    }, [user, profile, executor, company, setProfile, setExecutor, setCompany, setCompanies, companies, userLoginResult, companyOperators, setCompanyOperators]);

    return user ? (
        <Stack width="full">
            <Flex bg="lightgrey" p={4} color="white" justifyContent="center" w="100%">
                <Center flex="1">
                    <Select.Root
                        value={[company ? String(company.ID) : ""]}
                        // defaultValue={[String(inputParams.executorContractId)]}
                        collection={companiesList}
                        onValueChange={(e: any) => {
                            if (companies) {
                                const id = parseInt(e.value[0]);
                                const f = companies.find(o => o.ID === id);
                                if (f)
                                    setCompany(f);
                            }
                        }}>
                        <Select.HiddenSelect/>
                        <Select.Control>
                            <Select.Trigger>
                                <Select.ValueText placeholder="Компания"/>
                            </Select.Trigger>
                            <Select.IndicatorGroup>
                                <Select.Indicator/>
                            </Select.IndicatorGroup>
                        </Select.Control>
                        <Select.Positioner>
                            <Select.Content>
                                {companiesList.items.map((it: any) => (
                                    <Select.Item item={it} key={it.value}>
                                        {it.label}
                                        <Select.ItemIndicator/>
                                    </Select.Item>
                                ))}
                            </Select.Content>
                        </Select.Positioner>
                    </Select.Root>
                </Center>
                <Center flex="1">
                    <Text fontSize="xl">ArmPay</Text>
                </Center>
                <Flex flex="1" gap="4" justify="flex-end">
                    <NavLink to="/profile"><LuUser/> Профиль</NavLink>
                    <NavLink to="/sec"><LuUser/> Безопасность</NavLink>
                    <Link css={{
                        // "--webkit-align-items": "top", "display": "block",
                        "color": "white"
                    }} onClick={ignore => logout()}><LuLogOut/> Выйти</Link>
                </Flex>
            </Flex>
            <InitDlg/>
        </Stack>
    ) : (
        <></>
    )
};

export default Header
